// Thin, safe wrappers around the GA4 gtag() global installed in public/index.html.
//
// Every function no-ops gracefully when gtag isn't available (local dev without a
// Measurement ID, ad blockers, script load failure), so callers never need to guard.

export const ANALYTICS_CONSENT_KEY = 'np_analytics_consent';

function hasGtag() {
	return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

// Fire a custom GA4 event, e.g. track('buy_intent', { item_name: '...' }).
export function track(eventName, params = {}) {
	if (hasGtag()) {
		window.gtag('event', eventName, params);
	}
}

// Consent Mode helpers. The banner calls these; index.html applies the stored
// choice on page load before GA config runs.
export function grantAnalyticsConsent() {
	try { localStorage.setItem(ANALYTICS_CONSENT_KEY, 'granted'); } catch (e) { /* ignore */ }
	if (hasGtag()) {
		window.gtag('consent', 'update', { analytics_storage: 'granted' });
	}
}

export function denyAnalyticsConsent() {
	try { localStorage.setItem(ANALYTICS_CONSENT_KEY, 'denied'); } catch (e) { /* ignore */ }
	if (hasGtag()) {
		window.gtag('consent', 'update', { analytics_storage: 'denied' });
	}
}

// Returns 'granted', 'denied', or null (no choice made yet).
export function getStoredConsent() {
	try { return localStorage.getItem(ANALYTICS_CONSENT_KEY); } catch (e) { return null; }
}
